<template>
    <div v-if="toAdd && !collapsed">

        <h4>Add Condition</h4>
        
        <b-form-group id="input-group-1" label="Slot:" label-for="input-1" description="Slot">
            <b-form-select id="input-1" v-model="new_condition.slot" value-field="name" text-field="name"
                :options="nonDefaultSlots" required></b-form-select>
        </b-form-group>

        <b-form-group id="input-group-2" label="Type:" label-for="input-2" description="Condition Type">
            <b-form-select id="input-3" v-model="new_condition.condition_type" :options="conditionTypes"
                required></b-form-select>
        </b-form-group>

        <b-form-group id="input-group-3" label="Value:" label-for="input-3" description="Your condition value"
            v-if="new_condition.condition_type == 'slot_value_in_list'">
            <b-form-input id="input-3" v-model="new_condition.value" required></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-3" label="Value:" label-for="input-3" description="Your condition value"
            v-if="new_condition.condition_type == 'slot_value_equal_to'">
            <b-form-input id="input-3" v-model="new_condition.value" required></b-form-input>
        </b-form-group>

        <b-row>

            <b-col>

                <b-button :disabled="!new_condition.slot" @click="addCondition(new_condition)" variant="primary"
                    style="width: 100%">Save</b-button>

            </b-col>

            <b-col>
                <b-button @click="cancelAddCondition" style="width: 100%" variant="danger">Cancel</b-button>
            </b-col>

        </b-row>


    </div>
</template>

<script>

export default {
    name: 'ConditionAdd',
    props: {
        nonDefaultSlots: {
            type: Array | Object
        },
        addCondition: {
            type: Function
        },
        collapsed: {
            type: Boolean
        },
        toAdd: {
            type: Boolean
        },
        toAddValue: {
            type: Boolean
        },
        cancelAddCondition: {
            type: Function
        },
    },
    data() {
        return {
            conditionTypes: [
                {
                    text: "is not set",
                    value: "slot_value_unset",
                },
                {
                    text: "Equals",
                    value: "slot_value_equal_to",
                },
                {
                    text: "Is in list",
                    value: "slot_value_in_list",
                },
            ],
            new_condition: {
                slot: '',
                condition_type: '',
                value: ''
            }
        }
    },
    methods: {
        stringTOId(str, egidx) {
            return str + "-" + egidx;
        },
        reset_new_condition() {
            this.new_condition = {
                slot: '',
                condition_type: '',
                value: ''
            }
        }
    
    }
}


</script>
